import { useSvgToRaster } from "./SvgToRasterContext";
import { useMemo, useState } from "react";

export function SvgToRasterViewer() {
    const {
        rasterImageDataUrl,
        width,
        height,
        antiAliasing,
        canExport,
        handleDownload,
    } = useSvgToRaster();

    const [zoom, setZoom] = useState(1);

    const zoomIn = () => {
        setZoom((prev) => Math.min(prev * 1.2, 10));
    };

    const zoomOut = () => {
        setZoom((prev) => Math.max(prev / 1.2, 0.1));
    };

    const resetZoom = () => {
        setZoom(1);
    };

    const containerDimensions = useMemo(() => {
        if (!rasterImageDataUrl) return null;

        const baseWidth = width;
        const baseHeight = height;

        // Scale dimensions by zoom
        return {
            width: baseWidth * zoom,
            height: baseHeight * zoom,
        };
    }, [rasterImageDataUrl, width, height, zoom]);

    return (
        <div className="svg-to-raster-viewer">
            <div className="path-tool-preview">
                <div className="svg-zoom-controls">
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomOut}
                        title="Zoom out"
                    >
                        −
                    </button>
                    <span className="zoom-level">
                        {Math.round(zoom * 100)}%
                    </span>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomIn}
                        title="Zoom in"
                    >
                        +
                    </button>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={resetZoom}
                        title="Reset zoom"
                    >
                        ⌂
                    </button>
                </div>
                <div className="svg-scroll-wrapper">
                    <div
                        className="svg-container"
                        style={
                            containerDimensions
                                ? {
                                      width: `${containerDimensions.width}px`,
                                      height: `${containerDimensions.height}px`,
                                  }
                                : undefined
                        }
                    >
                        {rasterImageDataUrl ? (
                            <img
                                src={rasterImageDataUrl}
                                alt="Raster image preview"
                                style={{
                                    width: `${width * zoom}px`,
                                    height: `${height * zoom}px`,
                                    imageRendering: antiAliasing
                                        ? "auto"
                                        : "pixelated", // Conditional rendering based on anti-aliasing
                                }}
                            />
                        ) : (
                            <div className="svg-placeholder">
                                <p>Raster image will appear here</p>
                                <p className="svg-placeholder-hint">
                                    Upload an SVG and click "Generate Raster
                                    Image"
                                </p>
                            </div>
                        )}
                    </div>
                </div>
                <div className="path-tool-footer">
                    <p className="path-tool-meta">
                        {rasterImageDataUrl
                            ? `Raster image: ${width}×${height} pixels`
                            : "No raster image generated yet."}
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        disabled={!canExport}
                        onClick={handleDownload}
                    >
                        Download PNG
                    </button>
                </div>
            </div>
        </div>
    );
}
